

import Updates from './updates/updates';


const SELECTOR = '[data-archicadupdates]';

// todo: get version from db
const localizationMap = {
    'WW': ['INT', '26'],
    'AU': ['AUS', '26'],
    'AT': ['AUT', '26'],
    'BR': ['BRA', '26'],
    'CH': ['INT', '26'],
    'CN': ['CHI', '26'],
    'CZ': ['CZE', '26'],
    'DE': ['GER', '26'],
    'ES': ['SPA', '26'],
    'FI': ['FIN', '26'],
    'FR': ['FRA', '26'],
    'GB': ['UKI', '26'],
    'GR': ['GRE', '26'],
    'HU': ['HUN', '26'],
    'IE': ['UKI', '26'],
    'IT': ['ITA', '26'],
    'JP': ['JPN', '26'],
    'KR': ['KOR', '26'],
    'NL': ['NED', '26'],
    'NO': ['NOR', '26'],
    'NZ': ['NZE', '26'],
    'PL': ['POL', '26'],
    'PT': ['POR', '26'],
    'RU': ['RUS', '26'],
    'SE': ['SWE', '26'],
    'TR': ['TUR', '26'],
    'TW': ['TAI', '26'],
    'UA': ['UKR', '26'],
    'US': ['USA', '26'],
};



/**
 * Get localization based on IP
 */
const getGeoLocalization = function() {
    console.log('getGeoLocalization()');

    let geoTag = document.querySelector('meta[name="geo"]'),
        countryCode = (geoTag && geoTag.content) || 'WW',
        geoLocalization = localizationMap[countryCode] || localizationMap['WW'];

    return {
        'localization'  : geoLocalization[0],
        'version'       : geoLocalization[1],
        'type'          : geoLocalization[2] || 'FULL',
    };
}

/**
 * Get localization based on IP
 */
const cleanURLParameters = function(parameterNames) {
    console.log('cleanURLParameters() [parameterNames]', parameterNames);

    let url = new URL(window.location.href);

    parameterNames.forEach((parameterName) => {
        url.searchParams.delete(parameterName);
    });
    
    history.replaceState(null, null, url);
};
/**/

/**
 * Setup defaults
 */
const getDefaults = function() {
    let urlParams = new URLSearchParams(window.location.search),
        requestedSet = {
            'type'          : urlParams.get('productType') || urlParams.get('type'),
            'version'       : urlParams.get('gsversion') || urlParams.get('version'),
            'localization'  : urlParams.get('gslang') || urlParams.get('localization'),
        },
        geoLocalizationSet = getGeoLocalization(),
        defaultSet = {
            'type'          : requestedSet.type || geoLocalizationSet.type,
            'version'       : requestedSet.version || geoLocalizationSet.version,
            'localization'  : requestedSet.localization || geoLocalizationSet.localization,
        }
    ;
    
    cleanURLParameters(['gstype', 'gsversion', 'gslang']);

    console.log('getDefaults() [defaultSet]', defaultSet);

    return defaultSet;
}


let updates = Updates.init(SELECTOR),
    updateDefaults = getDefaults();

console.log('[updateDefaults]', updateDefaults);

updates.forEach(update => {
    update.ready.then(() => {
        Object.entries(updateDefaults).forEach((updateDefault) => {
            update.setFilter(updateDefault[0], updateDefault[1]);
        });
    })
});
